import { gql } from "@apollo/client";

export const GET_PDR_VIDEOS = gql`
  query GetVideosQuery($creditCategory: [MembershipCreditCategory!], $series: [String!]) {
    videoSeries
    videos(creditCategory: $creditCategory, series: $series) {
      id
      title
      description
      series
      publishedAt
      expiredAt
      creditCategory
      url
      duration
      durationInSeconds
      memberVideoStatus
    }
  }
`;
